import { render, staticRenderFns } from "./DeliveryFee.vue?vue&type=template&id=5375f6f1&scoped=true"
import script from "./DeliveryFee.vue?vue&type=script&lang=js"
export * from "./DeliveryFee.vue?vue&type=script&lang=js"
import style0 from "./DeliveryFee.vue?vue&type=style&index=0&id=5375f6f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5375f6f1",
  null
  
)

export default component.exports